import { ChangeDetectionStrategy, Component, Input, ViewChild, inject } from "@angular/core";
import { AuditQuestionnaireComponent, AuditResponseChange } from "../../components/audit-questionnaire/audit-questionnaire.component";
import { ConfirmCleanDialogComponent } from "../../components/confirm-clean-dialog/confirm-clean-dialog.component";
import { SAFETY_QUESTIONS } from "../../data/lab-audit-questions";
import { LabPersonnel } from "../../models/lab-audit.models";
import { LabAuditStateService } from "../../services/lab-audit-state.service";

@Component({
  selector: "app-safety-tab",
  standalone: true,
  imports: [AuditQuestionnaireComponent, ConfirmCleanDialogComponent],
  templateUrl: "./safety-tab.component.html",
  styleUrl: "./safety-tab.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SafetyTabComponent {
  @Input() printMode = false;
  @ViewChild(ConfirmCleanDialogComponent) private cleanDialog?: ConfirmCleanDialogComponent;
  readonly auditState = inject(LabAuditStateService);
  readonly questions = SAFETY_QUESTIONS;
  view: "personnel" | "questions" = "questions";

  updateResponse(change: AuditResponseChange): void {
    this.auditState.updateResponse("safety", change.questionId, change.changes);
  }

  updatePersonnel(index: number, field: keyof LabPersonnel, event: Event): void {
    this.auditState.updatePersonnel(index, field, (event.target as HTMLInputElement).value);
  }

  openCleanDialog(): void {
    this.cleanDialog?.open();
  }
}
